import { c as _c } from "react/compiler-runtime";
import type { DocumentKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useDocListText = () => {
  const $0 = _c(3);
  let t0;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "id_document"
    };
    $0[0] = t0;
  } else {
    t0 = $0[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($0[1] !== t) {
    t1 = docs => [...docs].map(doc => t($ => $[doc]) as DocumentKind).sort(_temp);
    $0[1] = t;
    $0[2] = t1;
  } else {
    t1 = $0[2];
  }
  return t1;
};
export default useDocListText;
function _temp(a, b) {
  return a.localeCompare(b);
}